import React from 'react';

interface LogoTextProps {
  size?: 'sm' | 'md' | 'lg';
}

const LogoText: React.FC<LogoTextProps> = ({ size = 'md' }) => {
  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-3xl'
  };

  return (
    <div className={`ml-3 font-bold ${textSizes[size]}`}>
      <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent">
        Scale
      </span>
      <span className="text-indigo-600">Nix</span>
      <span className="block text-xs text-gray-500 font-medium mt-0.5">
        Open Source Solutions
      </span>
    </div>
  );
};

export default LogoText;